import { render, staticRenderFns } from "./SectionDataConsent.vue?vue&type=template&id=e7b249a2&scoped=true&"
import script from "./SectionDataConsent.vue?vue&type=script&lang=js&"
export * from "./SectionDataConsent.vue?vue&type=script&lang=js&"
import style0 from "./SectionDataConsent.vue?vue&type=style&index=0&id=e7b249a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b249a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
